import { render } from "./HeaderTab.vue?vue&type=template&id=e90d90da"
import script from "./HeaderTab.vue?vue&type=script&lang=js"
export * from "./HeaderTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\giord\\Documents\\Progetti VS\\sito-giordan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__